import React from "react";

import "../../../adminAssets/css/style.css";
import "../../../adminAssets/css/style-preset.css";


const AdminHeader = () => {
    return(
    <>
    <header className="pc-header">
        <div className="header-wrapper">
            <div className="me-auto pc-mob-drp flex-center fw-semibold text_quicksand" style={{color:"#1A1A1A"}}>
                <ul className="breadcrumb fw-bold text-18">
                {/* <li className="breadcrumb-item"><a href="../dashboard/index.html">Home</a></li>
                <li className="breadcrumb-item"><a href="javascript: void(0)">DataTable</a></li>
                <li className="breadcrumb-item" aria-current="page">Basic Int.</li> */}
                    <li className="breadcrumb-item" aria-current="page">My Product</li>
                </ul>
                <ul className="list-unstyled">
                    <li className="pc-h-item header-mobile-collapse d-none">
                        <a href="#" className="pc-head-link head-link-secondary ms-0" id="sidebar-hide">
                            <i className="ti ti-menu-2"></i>
                        </a>
                    </li>
                    <li className="pc-h-item pc-sidebar-popup">
                        <a href="#" className="pc-head-link head-link-secondary ms-0" id="mobile-collapse">
                            <i className="ti ti-menu-2"></i>
                        </a>
                    </li>
                    <li className="dropdown pc-h-item d-inline-flex d-md-none">
                        <a className="pc-head-link head-link-secondary dropdown-toggle arrow-none m-0" data-bs-toggle="dropdown" href="#"
                           role="button" aria-haspopup="false" aria-expanded="false">
                            <i className="ti ti-search"></i>
                        </a>
                        <div className="dropdown-menu pc-h-dropdown drp-search">
                            <form className="px-3">
                                <div className="form-group mb-0 d-flex align-items-center">
                                    <i data-feather="search"></i>
                                    <input type="search" className="form-control border-0 shadow-none" placeholder="Search here. . ." />
                                </div>
                            </form>
                        </div>
                    </li>
                    <li className="pc-h-item d-none d-md-inline-flex">
                        <form className="header-search d-none">
                            <i data-feather="search" className="icon-search"></i>
                            <input type="search" className="form-control" placeholder="Search here. . ." />
                            <button className="btn btn-light-secondary btn-search"><i className="i-block" data-clipboard-text="filter" data-bs-toggle="tooltip" data-filter="filter" aria-label="filter" data-bs-original-title="filter"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-filter"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg></i></button>
                        </form>
                    </li>
                </ul>
            </div>
            <div className="ms-auto">
                <ul className="list-unstyled">
                    <li className="dropdown pc-h-item pc-mega-menu d-none">
                        <a className="pc-head-link head-link-secondary dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" href="#"
                           role="button" aria-haspopup="false" aria-expanded="false">
                            <i className="ti ti-access-point"></i>
                        </a>
                        <div className="dropdown-menu pc-h-dropdown pc-mega-dmenu">
                            <div className="row g-0">
                                <div className="col text-center image-block">
                                    <img src="../adminassets/images/pages/img-megamenu.svg" alt="image" className="img-fluid rounded" />
                                </div>
                                <div className="col">
                                    <h6 className="mega-title">UI Components</h6>
                                    <ul className="pc-mega-list">
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Alerts</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Accordions</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Avatars</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Badges</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Breadcrumbs</a></li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <h6 className="mega-title">UI Components</h6>
                                    <ul className="pc-mega-list">
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Menus</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Modals</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Pagination</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Search Bar</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Tabs</a></li>
                                    </ul>
                                </div>
                                <div className="col">
                                    <h6 className="mega-title">Advance Components</h6>
                                    <ul className="pc-mega-list">
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Advanced Stats</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Advanced Cards</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Lightbox</a></li>
                                        <li><a href="#!" className="dropdown-item"><i className="fas fa-circle"></i> Notification</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="dropdown pc-h-item d-none">
                        <a className="pc-head-link head-link-primary dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" href="#"
                           role="button" aria-haspopup="false" aria-expanded="false">
                            <i className="ti ti-language"></i>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end pc-h-dropdown">
                            <a href="#!" className="dropdown-item">
                                <span>English <small>(UK)</small></span>
                            </a>
                            <a href="#!" className="dropdown-item">
                                <span>français <small>(French)</small></span>
                            </a>
                            <a href="#!" className="dropdown-item">
                                <span>Română <small>(Romanian)</small></span>
                            </a>
                            <a href="#!" className="dropdown-item">
                                <span>中国人 <small>(Chinese)</small></span>
                            </a>
                        </div>
                    </li>
                    <li className="dropdown pc-h-item ">
                        <a className="pc-head-link head-link-secondary dropdown-toggle arrow-none me-0" data-bs-toggle="" id="notification_caller" href="#"
                           role="button" aria-haspopup="false" aria-expanded="false">
                            <i className="ti ti-bell"></i>
                        </a>
                        <div className="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown" id="notification_element">
                            <div className="dropdown-header">
                                <a href="#!" className="link-primary float-end text-decoration-underline mass_notifRead">Mark as all read</a>
                                <h5>All Notification <span className="badge bg-warning rounded-pill ms-1">01</span></h5>
                            </div>
                            <div className="dropdown-header px-0 text-wrap header-notification-scroll position-relative"
                                 style={{maxHeight:"calc(100vh - 215px)"}}>
                                <div className="list-group list-group-flush w-100">
                                    <div className="list-group-item">
                                        <select className="form-select">
                                            <option value="all">All Notification</option>
                                            <option value="new">New</option>
                                            <option value="unread">Unread</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div id="notification_container">
                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <img src="/assets/images/icon/User-round.png" alt="user-image" className="user-avtar" />
                                                </div>
                                                <div className="flex-grow-1 ms-1">
                                                    <span className="float-end text-muted">2 min ago</span>
                                                    <h5 className="userName_Dashboard">@currentMember.Name</h5>
                                                    <p className="text-body fs-6">It is a long established fact that a reader will be distracted </p>
                                                    <div className="badge rounded-pill bg-light-danger">Unread</div>
                                                    <div className="badge rounded-pill bg-light-warning">New</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <div className="user-avtar bg-light-success"><i className="ti ti-building-store"></i></div>
                                                </div>
                                                <div className="flex-grow-1 ms-1">
                                                    <span className="float-end text-muted">3 min ago</span>
                                                    <h5>Store Verification Done</h5>
                                                    <p className="text-body fs-6">We have successfully received your request.</p>
                                                    <div className="badge rounded-pill bg-light-danger">Unread</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <div className="user-avtar bg-light-primary"><i className="ti ti-mailbox"></i></div>
                                                </div>
                                                <div className="flex-grow-1 ms-1">
                                                    <span className="float-end text-muted">5 min ago</span>
                                                    <h5>Check Your Mail.</h5>
                                                    <p className="text-body fs-6">All done! Now check your inbox as you're in for a sweet treat! </p>
                                                    <button className="btn btn-sm btn-primary">Mail <i className="ti ti-brand-telegram"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <img src="../adminassets/images/user/avatar-1.jpg" alt="user-image" className="user-avtar" />
                                                </div>
                                                <div className="flex-grow-1 ms-1">
                                                    <span className="float-end text-muted">8 min ago</span>
                                                    <h5>John Doe</h5>
                                                    <p className="text-body fs-6">Uploaded two file on &nbsp;<strong>21 Jan 2020</strong></p>
                                                    <div className="notification-file d-flex p-3 bg-light-secondary rounded">
                                                        <i className="ti ti-arrow-bar-to-down"></i>
                                                        <h5 className="m-0">demo.jpg</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-group-item list-group-item-action">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <img src="../adminassets/images/user/avatar-3.jpg" alt="user-image" className="user-avtar" />
                                                </div>
                                                <div className="flex-grow-1 ms-1">
                                                    <span className="float-end text-muted">10 min ago</span>
                                                    <h5>Joseph William</h5>
                                                    <p className="text-body fs-6">It is a long established fact that a reader will be distracted </p>
                                                    <div className="badge rounded-pill bg-light-success">Confirmation of Account</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="list-group-item">
                                        <button className="btn btn-primary" id="btn_notifloadMore">Load More</button>
                                    </div>
                                </div>
                            </div>
                            <div className="dropdown-divider"></div>
                            <div className="text-center py-2">
                                <a href="#!" className="link-primary mass_notifRead">Mark as all read</a>
                            </div>
                        </div>
                    </li>
                    <li className="dropdown pc-h-item header-user-profile">
                        <a className="pc-head-link head-link-primary dropdown-toggle arrow-none me-0" data-bs-toggle="dropdown" href="#"
                           role="button" aria-haspopup="false" aria-expanded="false">
                            <img src="/assets/images/icon/User-round.png" alt="user-image" className="user-avtar" />
                            <span>
                                <i className="ti ti-settings"></i>
                            </span>
                        </a>
                        <div className="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown">
                            <div className="dropdown-header">
                                <h4 className="text-16">Good Morning, <span className="small text-muted  userName_Dashboard" id=""> @currentMember.Name</span></h4>
                                <p className="text-muted d-none">Project Admin</p>
                                <form className="header-search d-none">
                                    <i data-feather="search" className="icon-search"></i>
                                    <input type="search" className="form-control" placeholder="Search profile options" />
                                </form>
                                <hr />
                                <div className="profile-notification-scroll position-relative" style={{maxHeight: "calc(100vh - 280px)"}}>
                                    <div className="upgradeplan-block bg-light-warning rounded d-none">
                                        <h4>Explore full code</h4>
                                        <p className="text-muted">Buy now to get full access of code files</p>
                                        <a href="https://codedthemes.com/item/berry-bootstrap-5-admin-template/" target="_blank"
                                           className="btn btn-warning">Buy Now</a>
                                    </div>
                                    <hr className="d-none" />
                                    <div className="settings-block bg-light-primary rounded d-none">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                                            <label className="form-check-label" for="flexSwitchCheckDefault">Start DND Mode</label>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked />
                                            <label className="form-check-label" for="flexSwitchCheckChecked">Allow Notifications</label>
                                        </div>
                                    </div>
                                    <hr className="d-none" />
                                    <a href="../application/account-profile-v1.html" className="dropdown-item d-none">
                                        <i className="ti ti-settings"></i>
                                        <span>Account Settings</span>
                                    </a>
                                    <a href="../application/social-profile.html" className="dropdown-item d-none">
                                        <i className="ti ti-user"></i>
                                        <span>Social Profile</span>
                                    </a>
                                    <a href="" id="link_logout" className="dropdown-item">
                                        <i className="ti ti-logout"></i>
                                        <span>Logout</span>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </header>

    </>
    )
}

export default AdminHeader;